import React, { useEffect, useState } from "react";
import Edit from "../../Assets/img/Edit.svg";
import { useNavigate } from "react-router-dom";
import API from "../Service/Baseservice";
import Search from "../../Assets/img/search.png";
import Loading from "../../Loading/loading";
import "../ContactUs/Contact.css";

const ContactUs = () => {
    const navigate = useNavigate();

    const [search, setSearch] = useState("");
    const [status, setStatus] = useState("");
    const [languageId, setLanguageId] = useState(1);
    const [contactList, setContactList] = useState([]);
    const [loading, setLoading] = useState(true);

    /** 🔁 Redirect map (EN + FR) */
    const redirectMap = {
        "social support": "editsocial",
        "soutien social": "editsocial",

        "contact us": "editcontact",
        "contactez-nous": "editcontact",

        "map": "editmap",
        "carte": "editmap",
    };

    const normalize = (str) =>
        str?.replace(/\s+/g, " ").trim().toLowerCase();

    /** 📡 Fetch ContactUs */
    const fetchContactUs = () => {
        setLoading(true);

        API.post("contactus_list/condition", {
            language_id: languageId,
            search,
            status,
        })
            .then((res) => {
                const list = res?.data?.data?.data || [];

                const updated = list.map((item) => ({
                    ...item,
                    redirect: redirectMap[normalize(item.heading)] || "",
                }));

                setContactList(updated);
            })
            .catch((err) => {
                console.error("ContactUs fetch error:", err);
                setContactList([]);
            })
            .finally(() => setLoading(false));
    };

    useEffect(() => {
        fetchContactUs();
    }, [languageId]);

    const handleToggleStatus = (id, currentStatus) => {
        const newStatus = currentStatus === "active" ? "inactive" : "active";

        setLoading(true);

        API.post("contactus_status/update", {
            contact_id: id,
            status: newStatus,
        })
            .then(() => fetchContactUs())
            .catch((err) => console.error("Failed to update status:", err))
            .finally(() => setLoading(false));
    };
    return (
        <div className="news-container1">


            <div className="services-header1">
                <h2 className="services-title1">Contact Us</h2>
            </div>

            {/* FILTER SECTION */}
            <div className="category-filter-row1">
                <div className="category-filter-block1">
                    <label>Search By</label>
                    <div className="category-input-container1">
                        <input
                            placeholder="Search Contact Us..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                            className="category-input-field1"
                        />
                    </div>
                </div>

                <div className="category-filter-block1">
                    <label>Status</label>
                    <div className="category-input-container1">
                        <select
                            className="category-input-field1"
                            value={status}
                            onChange={(e) => setStatus(e.target.value)}
                        >
                            <option value="">Select Status</option>
                            <option value="active">Active</option>
                            <option value="inactive">Inactive</option>
                        </select>
                    </div>
                </div>

                <div className="filter-block">
                    <label>Language</label>
                    <div className="input-container">
                        <select
                            onChange={(e) => setLanguageId(Number(e.target.value))}
                            value={languageId}
                            className="input-field"
                        >
                            <option value="1">English</option>
                            <option value="2">Français</option>
                        </select>
                    </div>
                </div>

                <div
                    className="filter-btn-wrapper"
                    onClick={() => fetchContactUs()}
                >
                    <img src={Search} alt="Filter" className="icon-btnf" />
                </div>
            </div>


            {/* LIST */}
            {loading ? (
                <Loading />
            ) : (
                <div className="news-grid3">
                    {contactList.length > 0 ? (
                        contactList.map((item) => (
                            <div className="news-card1" key={item.contact_id}>
                                <p>{item.heading}</p>


                                <div className="card-footer1">
                                    <div className="status-container">
                                        <label className="category-switch">
                                            <input
                                                type="checkbox"
                                                checked={item.status === "active"}
                                                onChange={() =>
                                                    handleToggleStatus(
                                                        item.contact_id,
                                                        item.status
                                                    )
                                                }
                                            />
                                            <span className="category-slider round">
                                                <span className="category-switch-label">
                                                    {item.status === "active" ? "ON" : "OFF"}
                                                </span>
                                            </span>
                                        </label>
                                    </div>

                                    <div className="action-buttons1">
                                        <img
                                            src={Edit}
                                            alt="Edit"
                                            className="icon-btn1"
                                            onClick={() =>
                                                navigate(`/${item.redirect}`, {
                                                    state: { languageId }
                                                })
                                            }
                                        />
                                    </div>
                                </div>
                            </div>
                        ))
                    ) : (
                        <p className="no-news-text">No ContactUs found.</p>
                    )}
                </div>
            )}
        </div>
    );
};

export default ContactUs;
